import React, { createContext, useContext, useState, useEffect } from 'react';
import axiosInstance from '../utils/axios';

const AuthContext = createContext();

export function AuthContextProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setName] = useState(null);
  const [userEmail, setEmail] = useState(null);
  const [userId, setUserId] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if token exists in localStorage on initial load
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setIsAuthenticated(true);
      setToken(storedToken);
      // Optionally fetch user data here using the token
    }
    setLoading(false);
  }, []);

  const login = async (credentials, navigate) => {
    try {
      //console.log("***credentials, i am here");
      const response = await axiosInstance.post('/login', credentials);
      
      const data = response.data;
      
      // Save token to sessionStorage
      if (data.loginStatus == 'true') {
        sessionStorage.setItem('token', data.token);
        sessionStorage.setItem('userId', data.userId);
        sessionStorage.setItem('userName', data.userName);
        sessionStorage.setItem('userEmail', data.userId);
        sessionStorage.setItem('loginStatus', data.loginStatus);
        setToken(data.token);
        setName(data.userName);
        setEmail(credentials.userId);
        setUserId(data.userId);
        setIsAuthenticated(true);
 //console.log("***i am here");
        navigate("/landing");
      } else {
        return { success: false, error: "Invalid credentials, please try again." };
      }
      //return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      //return { success: false, error: error.message };
    }
  };

  const logout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('userName');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('loginStatus');
    setToken(null);
    setName(null);
    setEmail(null);
    setUserId(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider 
      value={{ 
        isAuthenticated, 
        setIsAuthenticated,
        username, 
        setName,
        userEmail,
        setEmail,
        userId,
        setUserId,
        token,
        setToken,
        login, 
        logout,
        loading 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthContextProvider');
  }
  return context;
}
